module.exports = __webpack_public_path__ + "img/pspo-1.7ced5467.svg";